<template>
    <div>
        <HeaderBox index="1"></HeaderBox>
        <div class="split"></div>
        <section>
            <article class="fl">
                <JottingList title="记忆碎片"></JottingList>
                <div class="split"></div>
                <ArticleList title="侧耳倾听"></ArticleList>
            </article>
            <AsideBox></AsideBox>
        </section>
        <FooterBox></FooterBox>
    </div>
</template>

<script>
import HeaderBox from '../components/HeaderBox'
import JottingList from '../components/JottingList'
import ArticleList from '../components/ArticleList'
import AsideBox from '../components/AsideBox'
import FooterBox from '../components/FooterBox'
export default {
    components: {HeaderBox,JottingList,ArticleList,AsideBox,FooterBox},
    inject: ['reload'],
    methods: {
        refreshTable () {
        this.reload()
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/IndexView.vue